import { Text } from '@heathmont/moon-components';
import { AuthCode } from '@heathmont/moon-core';
import Translate from '~/client/shared/i18n/Translate';
import Stack from '~/client/shared/Stack';
import HavingTroubles from './HavingTroubles';
import use2FAStep from './helpers/use2FAStep';

type Props = {
  authCodeErrorMessage: string;
  handleCodeSubmit: (code: string) => void;
};

const EnterOtpStep: FC<Props> = ({
  handleCodeSubmit,
  authCodeErrorMessage,
}) => {
  const { handleOpenComms, handleClearErrors } = use2FAStep();
  return (
    <form>
      <Stack>
        <Text size={14} color="trunks.100">
          <Translate id="profile.enter_code_from_app" />
        </Text>
        <AuthCode
          onlyDigits
          onSubmit={handleCodeSubmit}
          onChange={handleClearErrors}
          errorMessage={authCodeErrorMessage}
        />
        <HavingTroubles
          handleClick={handleOpenComms}
          translateId="profile.contact_support"
        />
      </Stack>
    </form>
  );
};

export default EnterOtpStep;
